import { FormSectionSimple } from 'components/layout/Section/FormSectionSimple';
import { NsKey } from 'enums/NsKey';
import { InputFactory } from 'factories/InputFactory';
import { LegalEntityFormFieldNames } from 'features/new-actor/enums/legalEntityFormFieldNames';
import { legalEntityContactInputsConfig } from 'features/new-actor/form/inputs-config/optim/legalEntityContactInputsConfig';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { BaseLayoutProps } from 'types/form/baseLayoutProps';
import { AddressFormFieldNames } from 'shared/enums/addressFormFieldNames';
import { NaturalPersonFormFieldNames } from '../../enums/naturalPersonFormFieldNames';
import { PersonalInformationFieldNames } from '../../enums/personalInformationFieldNames';

export const LegalEntityContactLayout: React.FC<BaseLayoutProps> = () => {
  const { t } = useTranslation(NsKey.ActorForm);

  const renderField = useCallback((fieldName: any) => {
    return (
      <InputFactory config={legalEntityContactInputsConfig} fieldName={fieldName} />
    );
  }, []);

  return (
    <div className="font-lato flex flex-col gap-4">
      <FormSectionSimple title={t('ACTOR_FORM.LABELS.CONTACT_SECTION')}>
        <>
          <div className="col-span-3">
            {renderField(PersonalInformationFieldNames.Civility)}
          </div>
          <div className="col-span-3">
            {renderField(LegalEntityFormFieldNames.CompanyRole)}
          </div>
          <div className="col-span-3">
            {renderField(PersonalInformationFieldNames.LastName)}
          </div>
          <div className="col-span-3">
            {renderField(PersonalInformationFieldNames.FirstName)}
          </div>
          <div className="col-span-3">
            {renderField(PersonalInformationFieldNames.BirthName)}
          </div>
          <div className="col-span-3">
            {renderField(PersonalInformationFieldNames.BirthCountry)}
          </div>
          <div className="col-span-3">
            {renderField(PersonalInformationFieldNames.Nationality)}
          </div>
          <div className="col-span-3">
            {renderField(PersonalInformationFieldNames.BirthDate)}
          </div>
          <div className="col-span-3">
            {renderField(PersonalInformationFieldNames.Email)}
          </div>
          <div className="col-span-3">
            {renderField(PersonalInformationFieldNames.Phone)}
          </div>
          <div className="col-span-3">
            {renderField(NaturalPersonFormFieldNames.TaxResidenceCountryId)}
          </div>
          <div className="w-full col-span-6 flex gap-4">
            <div className="flex-grow">
              {renderField(NaturalPersonFormFieldNames.IsPPE)}
            </div>
            <div className="flex-grow">
              {renderField(PersonalInformationFieldNames.IsFPE)}
            </div>
          </div>
        </>
      </FormSectionSimple>
      <FormSectionSimple title={t('ACTOR_FORM.LABELS.COORDINATE_SECTION')}>
        <>
          <div className="col-span-3">
            {renderField(AddressFormFieldNames.Address)}
          </div>
          <div className="col-span-3">
            {renderField(AddressFormFieldNames.AdditionalAddress)}
          </div>
          <div className="col-span-3">
            {renderField(AddressFormFieldNames.PostalCode)}
          </div>
          <div className="col-span-3">
            {renderField(AddressFormFieldNames.City)}
          </div>
          <div className="col-span-3">
            {renderField(AddressFormFieldNames.Country)}
          </div>
        </>
      </FormSectionSimple>
    </div>
  );
};
